import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = { class: "p-4 mb-4 pl-0" }
const _hoisted_5 = {
  key: 0,
  class: "wrong-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/scirt/wrongxpink.png",
    alt: "wrong symbol"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "font-extrabold text-3xl my-4 mt-8"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex flex-row mt-16 justify-center items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "bottom-0 sm:absolute p-2 sm:max-w-half"
}
const _hoisted_15 = ["href", "innerHTML"]
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.correct)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("h3", {
                class: "text-project font-bold text-5xl",
                innerHTML: _ctx.$t(_ctx.correct ? _ctx.config.titleAnsOk : _ctx.config.titleAnsWrong, {name: _ctx.state.nickname.value})
              }, null, 8, _hoisted_8),
              (!_ctx.config.hideCorrectAnswer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.config.correctAnswer[1])), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["mt-4", {'font-normal': _ctx.config.hideCorrectAnswer}]),
                innerHTML: _ctx.$t(_ctx.correct? _ctx.config.textAnsOk : _ctx.config.textAnsWrong, {name: _ctx.state.nickname.value})
              }, null, 10, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.config.image1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.config.image1,
                      class: "mr-8 w-24"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              class: "mt-auto"
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-4 flex-col items-center flex h-full justify-center", _ctx.config.rightSideClasses ?? ''])
          }, [
            _createElementVNode("img", {
              src: _ctx.config.bgImage,
              class: "max-h-75vh h-auto"
            }, null, 8, _hoisted_13)
          ], 2)
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_15))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_16))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}